// extracted by mini-css-extract-plugin
export default {"ChamberPage":"Chambers_ChamberPage__T-LIB","Chambers":"Chambers_Chambers__3plz1","head":"Chambers_head__wo0PR","body":"Chambers_body__YyQwi","btn":"Chambers_btn__DByea"};